var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import TextMediaAccordionItem from './textMediaAccordionItem';
import TextMediaAccordionItemContent from './textMediaAccordionItemContent';
import TextMediaAccordionItemTitle from './textMediaAccordionItemTitle';
import { Link } from 'react-router-dom';
import BgTransitionAnimation from '../../shared/bgTransitionAnimation';
import { hasGeoSegmentation, initGeosegmentationHtmlElProps } from '../../services/geoSegmentationService';
export default function StripTextMediaAccordion(props) {
    var fields = props.fields, children = props.children;
    var TitleTag = (fields.titleTag || 'h1');
    // Create an array to hold refs
    var refsArray = Array.from({ length: children && children.length }, function () { return useRef(null); });
    var firstActiveIndex = children && children.findIndex(function (item) { return !hasGeoSegmentation(item.fields); });
    var _a = useState(firstActiveIndex), itemIndex = _a[0], setItemIndex = _a[1];
    var _b = useState(firstActiveIndex), activeImgIndex = _b[0], setActiveImgIndex = _b[1];
    //const refItems = useRef(null);
    //const refItems = Array.from({ length: children.length }, () => useRef(null));
    //const moveUpMobile = (index: number) => {
    //    if (window.innerWidth < 768) {
    //    //    refItems.current?.scrollIntoView({
    //    //        behavior: 'smooth'
    //    //    });
    //    //    setTimeout(() => {
    //    //        window.scrollBy(0, -150);
    //    //    }, 500);
    //        let navBar = document.getElementById("navbar");
    //        console.log(refItems[index].current.getBoundingClientRect().top);
    //        const scrollOffset = refItems[index].current.getBoundingClientRect().top - (navBar ? navBar.offsetHeight + 20 : 0);
    //        window.scrollBy({ top: scrollOffset, behavior: 'smooth' });
    //    }
    //}
    useEffect(function () {
        children && children.forEach(function (child, index) {
            initGeosegmentationHtmlElProps(refsArray[index].current, child && child.fields);
        });
    }, []);
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-30%" }, className: "strip spa-text-media-accordion position-relative"
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + ((fields.color) ? (" bg-" + fields.color) : "")
            + ((fields.textColour) ? (" text-color-" + fields.textColour) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container-fluid " },
            fields.displayTitle &&
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" }, fields.displayTitle &&
                        React.createElement(TitleTag, { className: "title mb-4 " + fields.titleStyle, dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null)),
            !fields.displayAsInline && React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-6 order-2 order-md-1 accordion-content" },
                        React.createElement("ul", { className: "accordion-items" }, children && children.map(function (item, i) {
                            return (React.createElement(React.Fragment, { key: i },
                                React.createElement(TextMediaAccordionItem, { item: item, itemIndex: itemIndex, index: i, setItemIndex: setItemIndex, displayAsInline: fields.displayAsInline, children: children, setActiveImgIndex: setActiveImgIndex, activeImgIndex: activeImgIndex })));
                        }))),
                    React.createElement("div", { className: "col-md-6 order-1 order-md-2 mb-4 mb-md-0 accordion-image d-none d-md-block" },
                        React.createElement("div", { className: "accordion-img-container active" },
                            children && children.map(function (item, j) {
                                return (React.createElement(React.Fragment, { key: j },
                                    React.createElement(BgTransitionAnimation, { color1: item.fields.color1, color2: item.fields.color2, navigationState: itemIndex === j ? "loading" : "idle", transitionShownComplete: function () { setActiveImgIndex(itemIndex); } })));
                            }),
                            children && children.map(function (item, j) {
                                return (React.createElement(React.Fragment, { key: j * 2 },
                                    React.createElement("img", { src: item.fields.image, alt: item.fields.image_description ? item.fields.image_description : "FlyOver", className: "flyout-accordion-image " + (activeImgIndex === j ? " active" : "inactive") })));
                            })))),
                fields.linkLabel && React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "see-all text-end my-3" },
                        React.createElement(Link, { to: fields.link ? fields.link : "#", title: fields.linkLabel, className: "link-see-all learn-more me-3" }, fields.linkLabel))) || null) || null,
            fields.displayAsInline && children && children.map(function (item, k) {
                return (React.createElement(React.Fragment, { key: k },
                    React.createElement("div", { className: "row inline-item", ref: refsArray[k] },
                        React.createElement("div", { className: "col-md-6 order-2 order-md-1 accordion-content" },
                            React.createElement("ul", { className: "accordion-items" },
                                React.createElement("li", { className: "nav-item" },
                                    React.createElement("div", { className: "item-title" },
                                        React.createElement(TextMediaAccordionItemTitle, { item: item, i: k, displayAsInline: fields.displayAsInline })),
                                    React.createElement(TextMediaAccordionItemContent, { item: item, i: k })))),
                        React.createElement("div", { className: "col-md-6 order-1 order-md-2 accordion-image" }, item.fields.image && React.createElement("div", { className: "img-container pt-4 pt-md-0" },
                            React.createElement("img", { src: item.fields.image, alt: item.fields.image_description ? item.fields.image_description : "FlyOver", className: "flyout-accordion-image" })) || null))));
            }))));
}
